import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";
import { createSetInspectionDataAction } from "../actions/dataActions";
import {useGetAndSet} from "./useGetAndSet";

export const useInspectionData = (params, dataFresh) => {
  return useGetAndSet("inspections", params, createSetInspectionDataAction, dataFresh)
};
